/** The jungle world's palette (GDD: Art direction). Hex strings, used by the canvas art. */
export const JUNGLE = {
  skyBands: ['#140f2e', '#1d1640', '#2a2356', '#33386a', '#3b5470', '#3f6f73', '#6f8a6a'],
  glow: '#e0a35a',
  moonBig: '#e8d9b0',
  moonBigShade: '#b9a77e',
  moonSmall: '#9fd1c9',
  star: '#fff6d8',
  haze: '#4f7f86',

  mountain: '#2c3f63',
  mountainLit: '#3d5a80',
  mountainNear: '#28465a',
  mountainNearLit: '#386378',

  trunk: '#1b2f38',
  trunkLit: '#2a4750',
  canopy: '#1f4339',
  canopyLit: '#2c5d4a',
  vine: '#1a3830',
  undergrowth: '#1d3d34',

  grass: '#4fbf4a',
  grassLit: '#a6ec6a',
  grassDark: '#2f8a3a',
  dirt: '#5a3b2a',
  dirtDark: '#3e281d',
  pebble: '#7a5440',
  ink: '#120c0a',
  plank: '#8a5a33',
  plankLit: '#c48a52',
  plankDark: '#4a2c18',
  leaf: '#2f7a3f',

  fg: '#08140f',
  fgLit: '#123020',
} as const;

/** Deep space, for transits. */
export const SPACE = {
  void: '#07051a',
  nebula: '#160f38',
  star: '#fff6d8',
  starDim: '#6f76a8',
  starWarm: '#ffd23f',
  streak: '#9fd8ff',
  rock: '#6a5a52',
  rockLit: '#a08a78',
  rockDark: '#3a302c',
  crater: '#4a3e38',
} as const;

/** Radiation the suit isn't shielded for, and zones it is shielded for (world and HUD). */
export const RADIATION = { hot: '#b8ff3a', safe: '#7df9ff' } as const;

/** How much each lane is mixed toward the haze colour: farther lanes fade into the air. */
export const LANE_HAZE = [0, 0.3, 0.52] as const;

/** Mixes two #rrggbb colours; t = 0 gives a, t = 1 gives b. */
export function mix(a: string, b: string, t: number): string {
  const pa = parseInt(a.slice(1), 16);
  const pb = parseInt(b.slice(1), 16);
  const ch = (shift: number) => {
    const ca = (pa >> shift) & 0xff;
    const cb = (pb >> shift) & 0xff;
    return Math.round(ca + (cb - ca) * t);
  };
  const out = (ch(16) << 16) | (ch(8) << 8) | ch(0);
  return `#${out.toString(16).padStart(6, '0')}`;
}

/** Converts #rrggbb to a 0xrrggbb number (Phaser tints and fills). */
export function hexNumber(color: string): number {
  return parseInt(color.slice(1), 16);
}
